import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  addTier: {
    marginLeft: theme.spacing(1),
  },
  addTierContainer: {
    marginBottom: theme.spacing(1),
  },
  plusButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.customHeights.smallButton,
    height: theme.customHeights.smallButton,
    borderRadius: '50%',
    backgroundColor: theme.palette.common.blue400,
    color: theme.palette.common.white,
  },
  addTierButton: {
    '&:hover $plusButton': {
      backgroundColor: theme.palette.common.blue600,
    },
  },
  requirementContainer: {
    marginBottom: theme.spacing(3),

    '&:last-child': {
      marginBottom: theme.spacing(1),
    },
  },
}));
